import {
	BlogPostModuleType,
	HeroSubSectionType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"

export const blogExcerpt = (
	html: string | undefined,
	wordCount = 35,
): string => {
	if (!html) return ""

	const blogImgCaption =
		/<p\b[^>]*\bclass\s*=\s*["'][^"']*\bblog-img-caption\b[^"']*["'][^>]*>[\s\S]*?<\/p>/gi

	const text = html
		.replace(blogImgCaption, "")
		.replace(/<\/?(?:p|h[1-6])[^>]*?>/gim, "")
		.replace(/<[^>]+>|&[^;]+;/g, (match) => (match === "&amp;" ? "&" : ""))

	const words = text.trim().split(/\s+/).filter(Boolean)
	if (words.length <= wordCount) return words.join(" ")

	return `${words.slice(0, wordCount).join(" ")}...`
}

export const getFeaturedHeroPost = (
	posts?: BlogPostModuleType[],
): BlogPostModuleType | undefined => {
	if (!posts?.length) return undefined

	return posts.find((post) => post.featuredInHeroSection) ?? posts[0]
}

const byPostDateDesc = (a: BlogPostModuleType, b: BlogPostModuleType): number =>
	(b.postDate ?? 0) - (a.postDate ?? 0)

export const orderNewsList = (
	posts: BlogPostModuleType[],
): BlogPostModuleType[] => {
	const featured = posts
		.filter((post) => post.featuredOnTopOfNewsList)
		.sort(byPostDateDesc)
	const rest = posts
		.filter((post) => !post.featuredOnTopOfNewsList)
		.sort(byPostDateDesc)

	return [...featured, ...rest]
}

export const getHeroBlogContent = (
	items: HeroSubSectionType[] | undefined,
	post?: BlogPostModuleType,
): HeroSubSectionType[] | undefined => {
	if (!items?.length || !post) return items

	return items.map((item, index) => {
		if (index !== 1) return item

		const [button, ...rest] = item.buttons ?? []

		return {
			...item,
			title: post.title,
			description: blogExcerpt(post.content),
			buttons: button
				? [
						{
							...button,
							link: post.link,
							linkPopup: true,
						},
						...rest,
				  ]
				: item.buttons,
		}
	})
}
